import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {AccountClient} from "@app/_model/account.client";
import {AuthService} from "@app/_service";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {Logger} from "@app/logger";

@Component({
  selector: 'client-picker',
  standalone: true,
  templateUrl: './client.picker.html',
  styleUrls: ['./client.picker.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
  ]
})
export class ClientPicker implements OnInit {

  private readonly log = new Logger();

  enabled: boolean = false;
  accountClient?: AccountClient;
  accountClients?: AccountClient[];

  tooltipActiveProfile = $localize`:@@tooltipActiveProfile:Active profile`;
  textNoClient = $localize `No client`;

  constructor(
    private readonly authService: AuthService
  ) {
  }

  public ngOnInit(): void {
    this.authService.account.subscribe(account => {
      this.log.trace("account:", account);
      this.log.trace("account?.accountClients:", account?.accountClients);
      this.accountClients = account?.accountClients;
      this.log.trace('accountClients:', this.accountClients);
      this.enabled = !(this.authService.isNeed2fa);
      this.log.trace("enabled:", this.enabled);
    });
    this.authService.accountClientSubject?.subscribe(accountClient => {
      this.log.trace("accountClient:", accountClient);
      this.accountClient = accountClient || undefined;
    });
  }

  protected onClientChanged(accountClient: AccountClient): void {
    this.log.trace("onClientChanged accountClient:", accountClient);
    this.authService.setAccountClient(accountClient);
  }
}
